import React, { useEffect, useState } from 'react';
import Router from './router/Router';
import './App.css';
import Spinner from './Pages/Common/Spinner';


function App() {

  return (
    <div className='App' >
      <Router />
      <Spinner />
    </div>
  );
}

export default App;
